import React from 'react'
import Card, { CenterElement } from '../../components/Card'
import NewProjectForm from '../../containers/NewProjectForm'

const NewProject = () => (
  <CenterElement>
    <Card header={'Nowa ściana'}>
      <NewProjectForm maxWidth={'380px'} />
    </Card>
  </CenterElement>
)

export default NewProject



// WEBPACK FOOTER //
// ./src/screens/NewProject/index.js